import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState, useRef, useMemo} from 'react';
import {connect} from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TooltipPackageInfo from '../../Tooltip/TooltipPackageInfo';
import {goToPage} from '../../../../Page/SelfCarePage/SelfCareSlice';
import {internalPage, TAB_ENUM} from '../../../../Page/SelfCarePage/Constant';
import {UsageDetails, UsageTypes} from './constant';
import PopUp from '../../../../Shared/Popup/PopUp';
import MoreInfoPopup from './MoreInfoPopup';
import EpiContext from '@episerver/spa-core/Spa';
import {UpdateSubscriberName, getProductStatus} from '../../../../Page/SelfCarePage/Utilities';
import {dwhViewUsageInCountry} from 'app/Components/Page/SelfCarePage/partials/header/dwhReports';
import TooltipFuturePackageInfo from '../../Tooltip/TooltipFuturePackageInfo';

const CellularPackage = (props) => {
  const [packageMoreInfo, setPackageMoreInfo] = useState();
  const [dataUsage, setDataUsage] = useState(null);
  const [usages, setUsages] = useState([]);
  const [displayUsages, setDisplayUsages] = useState([]);
  const [openMoreInfo, setOpenMoreInfo] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [selectedUsage, setSelectedUsage] = useState('');
  const [productStatus, setProductStatus] = useState('');
  const [subscriberName, setSubscriberName] = useState('');
  const extendedDataLink = props.iContent.extendedDataUrl?.value;
  const extendedCallLink = props.iContent.extendedCallsUrl?.value;
  const moreInfoDataUsageLink = props.iContent.dataUsageLink?.value;
  const extendedInternationalLink = props.iContent.extendedInternationalCallsUrl?.value;
  const statusDesc = props.selectedSub ? getProductStatus(props.selectedSub) : null;
  const usageInfo = props.selectedSub?.cellularSurfingUseDetails;

  const canUpdateName = !(
    props.selectedSub?.productSubscriberNo == props.loginData?.userDetails?.contactNumber &&
    (props.loginData?.isFullAuthenticated || props.loginData.isOtpExtendedAuthenticated)
  );

  useEffect(() => {
    // reset when subscriber changed
    setOpenMoreInfo(false);
    setUsages([]);
    setDisplayUsages([]);
    //-------------------------
    if (props.selectedSub) {
      setSubscriberName(
        props.selectedSub.productFirstName ? props.selectedSub.productFirstName + ' ' + props.selectedSub.productLastName : 'מה שם המנוי? ',
      );
      if (usageInfo) {
        let usagesHelper = [];
        const {dataUsage, callsUsage, smsUsage, internationalUsage, ...rest} = usageInfo;
        if (dataUsage) {
          usagesHelper.push({
            ...dataUsage,
            name: UsageDetails.Data.name,
            measure: dataUsage.quantityUnitOfMeasure ?? UsageDetails.Data.measureUnit,
            type: UsageTypes.Data,
            link: extendedDataLink,
            moreInfoLink: moreInfoDataUsageLink,
          });
        }
        if (callsUsage) {
          usagesHelper.push({
            ...callsUsage,
            name: UsageDetails.Calls.name,
            measure: UsageDetails.Calls.measureUnit,
            type: UsageTypes.Calls,
            link: extendedCallLink,
          });
        }
        if (smsUsage) {
          usagesHelper.push({...smsUsage, name: UsageDetails.Sms.name, measure: UsageDetails.Sms.measureUnit, type: UsageTypes.Sms});
        }
        if (internationalUsage) {
          internationalUsage.forEach((usage) => {
            usagesHelper.push({
              ...usage,
              name: UsageDetails.InternationalCalls.name,
              measure: UsageDetails.InternationalCalls.measureUnit,
              type: UsageTypes.InternationalCalls,
              link: extendedInternationalLink,
            });
          });
        }
        if (usagesHelper.length > 0) {
          setDisplayUsages([usagesHelper[0]]);
          setUsages(usagesHelper);
        }
      }
    }
  }, [props.isFetchData, props.selectedSub]);

  useEffect(() => {
    if (usages.length > 0) {
      if (openMoreInfo) {
        setDisplayUsages(usages);
      } else {
        setDisplayUsages([usages[0]]);
      }
    }
  }, [openMoreInfo]);

  const isBundleCellular = () => {
    const {bundleInfo, selectedSub} = props;
    const selectedNumber = selectedSub?.productSubscriberNo;
    if (!Array.isArray(bundleInfo) || !selectedNumber) return false;
    const allCellular = bundleInfo.flatMap((b) => (Array.isArray(b.cellularItem) ? b.cellularItem : []));
    if (!allCellular.length) return false;
    const current = allCellular.find((c) => c.subscriberNumber === selectedNumber);
    return current?.bundleCellularInd === 'Y' || false;
  };

  const getColorByPercent = (percent) => {
    if (percent <= 25) {
      return 'light-purple';
    } else if (percent > 25 && percent <= 50) {
      return 'purple';
    } else if (percent > 50 && percent <= 75) {
      return 'dark-purple';
    } else if (percent > 75) {
      return 'red';
    }
  };

  const getUsedQuantity = (usage) => {
    if (usage.used > 0 && usage.type == UsageTypes.Data && usage.usedUnitOfMeasure == 'MB' && usage.quantityUnitOfMeasure == 'GB') {
      var used = usage.used * 0.001;
      return used.toFixed(2);
    } else {
      return usage.used;
    }
  };

  const openLimitInfoPopup = (el) => {
    setSelectedUsage(el);
    setShowPopUp(true);
  };

  function reportDwh() {
    const customerName = props.loginData.userDetails.firstName + ' ' + props.loginData.userDetails.lastName;
    const subscriber = props.loginData.userDetails.contactNumber;
    const idNumber = props.loginData.userDetails.IDNumber;
    const ban = props.selectedSub.ban;
    const psid = null;
    const crmId = null;
    const param1 = subscriber;
    const param9 = null;
    const param10 = null;
    dwhViewUsageInCountry(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10);
  }
  const getFutureSubDiv = () => {
    const recentPackage = props?.selfCareSuccess?.boughtCellularPackages?.find(
      (pc) => pc.subscriberNo === props.selectedSub?.productSubscriberNo,
    );
    if (recentPackage) {
      return (
        <div className='tipPackage'>
          <div className='tipUpperText'>
            קיימת בקשה לשינוי חבילה שתתעדכן {recentPackage.isImmediateTransitionPlan ? 'באופן מיידי' : `ב-${recentPackage.date}`}
          </div>
          <div className='tipLowerText'>
            החבילה החדשה: {recentPackage.title.replace(/&nbsp;/g, '')}{' '}
            <TooltipFuturePackageInfo isImmediate={recentPackage.isImmediateTransitionPlan} />
          </div>
        </div>
      );
    } else {
      return (
        <div className='tipPackage'>
          <div className='tipUpperText'>קיימת בקשה לשינוי חבילה שתתעדכן ב-{props.selectedSub?.futureSubPlanInfo?.planDate}</div>
          <div className='tipLowerText'>
            החבילה החדשה: {props.selectedSub?.futurePricePlanDesc}{' '}
            <TooltipFuturePackageInfo isImmediate={false} futurePackageInfo={props.selectedSub?.futureSubPlanInfo?.planInfo} />
          </div>
        </div>
      );
    }
  };
  const showFutureSubInfo =
    (!!props.selectedSub?.futureSubPlanInfo && props.selectedSub?.futureSubPlanInfo != {}) ||
    (!!props?.selfCareSuccess?.boughtCellularPackages?.find((pc) => pc.subscriberNo === props.selectedSub?.productSubscriberNo) &&
      props?.selfCareSuccess?.boughtCellularPackages?.find((pc) => pc.subscriberNo === props.selectedSub?.productSubscriberNo) != {});
  return (
    <div className='cellularUsageBlock'>
      <div className='cellular_package_block'>
        {showFutureSubInfo && getFutureSubDiv()}
        <div className={`package_details_container ${openMoreInfo ? 'openMoreInfo' : ''} ${!showFutureSubInfo ? 'brNoTip' : ''}`}>
          <div className='userDetails'>
            {props.selectedSub ? (
              <>
                <div className='subscriber'>
                  <div className='name'>
                    <span>{subscriberName}</span>
                    {canUpdateName && (
                      <Image onClick={() => UpdateSubscriberName(props.selectedSub, props.loginData, props.links)}
                        src={require('./../../images/edit.svg')}
                        alt='edit' />
                    )}
                  </div>
                  {statusDesc && <div className='product-status'>{statusDesc}</div>}
                </div>
                <div className='grayText'>{props.selectedSub?.productSubscriberNo}</div>
                {props.selectedSub?.pricePlanDesc ? (
                  <>
                    <div className='packageInfo grayText'>
                      <span>חבילה: {props.selectedSub?.pricePlanDesc}</span> <TooltipPackageInfo />
                    </div>
                    {isBundleCellular() && <div className='is-bundle'>חלק מחבילה משולבת</div>}
                  </>
                ) : (
                  <>{!props.isFetchData && <Skeleton style={{width: '50%'}} />}</>
                )}
              </>
            ) : (
              <Skeleton count={2} style={{width: '50%'}} />
            )}
          </div>
          <div className='usage_details'>
            {displayUsages && displayUsages.length > 0
              ? displayUsages.map((el, index) => {
                  const isExceededTheLimit = el.statusBarWidth >= 75;
                  return (
                    <>
                      {el.type == UsageTypes?.Data && usageInfo?.isUnlimited ? (
                        <>
                          {' '}
                          <span className='unlimited grayText usage_item'>
                            {' '}
                            ניצלת{' '}
                            <span className='used'>
                              {' '}
                              {getUsedQuantity(el)}
                              {el.usedUnitOfMeasure}
                            </span>{' '}
                            מתוך חבילת הגלישה שלך
                          </span>{' '}
                        </>
                      ) : (
                        <div key={index} className='usage_item'>
                          <span className='grayText usage_type'>{el.name}</span>{' '}
                          <div className='PercentageBar'>
                            <div
                              className={`percent  ${getColorByPercent(el.statusBarWidth)}`}
                              style={{width: `${Math.ceil(el.statusBarWidth)}%`}}></div>
                          </div>{' '}
                          <span className={`grayText usage_quantity ${isExceededTheLimit ? 'red' : ''}`}>
                            {getUsedQuantity(el)}/{el.quantity} {el.measure}
                          </span>
                        </div>
                      )}
                      {isExceededTheLimit && (
                        <div className='exceededLimitLink'>
                          {UsageDetails[el.type].displayExtendedLink && (
                            <span
                              onClick={() => {
                                EpiContext.navigateTo(el.link);
                                reportDwh();
                              }}>
                              {` ל${UsageDetails[el.type].btnText} `} &gt;{' '}
                            </span>
                          )}
                          <span
                            onClick={() => {
                              el.moreInfoLink ? EpiContext.navigateTo(el.moreInfoLink) : openLimitInfoPopup(el);
                            }}>
                            {' '}
                            למידע נוסף &gt;
                          </span>
                        </div>
                      )}
                    </>
                  );
                })
              : (!props.isFetchData || usageInfo?.dataUsage || usageInfo?.callsUsage || usageInfo?.smsUsage) && (
                  <Skeleton count={isBundleCellular() ? 6 : 5} />
                )}
            {openMoreInfo && (
              <div className='cycleDate'>
                <Image src={require('./../../images/calendar.svg')} />
                <span> נותרו {usageInfo?.cycleRemainingDays ?? 0} ימים עד סוף מחזור החיוב</span>
              </div>
            )}
          </div>
        </div>
        {usages.length > 0 && (
          <div className='moreInfo' onClick={() => setOpenMoreInfo(!openMoreInfo)}>
            <span className={openMoreInfo ? 'open' : ''}>{!openMoreInfo ? 'ספרו לי עוד' : 'סגירה'}</span>
          </div>
        )}
      </div>
      <PopUp className='moreInfo-popup-container' showPopUp={showPopup} onClose={() => setShowPopUp(false)}>
        <MoreInfoPopup setShowPopUp={setShowPopUp} usageInfo={selectedUsage} iContent={props.iContent} />
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loginData: state.authentication?.loginData,
    selectedSub: state.selfcarePage?.selectedSubscriber,
    isFetchData: state.selfcarePage?.isFetchData,
    links: state.selfcarePage.links,
    subscribersByProduct: state.selfcarePage.subscribersByProduct,
    selfCareSuccess: state.selfCareSuccessMsg,
    bundleInfo: state.selfcarePage?.productsBySubscriber?.Bundle,
  };
};

const mapDispatchToProps = {goToPage};

export default connect(mapStateToProps, mapDispatchToProps)(CellularPackage);
